<template>

  <Layout>
    <AboutView/>
    <router-view></router-view> <!-- 这里渲染 HomeView 或其他子路由的组件 -->
  </Layout>
</template>
<script>
import AboutView from "@/views/AboutView";
export default {
  components: {AboutView}
}
</script>
<style scoped>
a {
  text-decoration: none;
}
.box {
  display: flex;
}
</style>